/* eslint-disable react/forbid-prop-types */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  FaAngleDoubleLeft, FaCaretLeft, FaCaretRight, FaAngleDoubleRight,
} from 'react-icons/fa';
import EpButton from '../EpButton';
import './styles.scss';

const range = (from, to, step = 1) => {
  let i = from;
  const rangeArr = [];

  while (i <= to) {
    rangeArr.push(i);
    i += step;
  }

  return rangeArr;
};

const EpPagination = ({
  tableData, getDataFunc, pageNeighbours, filterData, integrationFuncData, columns,
  currentPageNumber, setCurrentPageNumber,
}) => {
  const { itensPerPage, totalPages, totalItens } = tableData;
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [hasPreviousControls, setHasPreviousControls] = useState(false);
  const [hasNextControls, setHasNextControls] = useState(false);
  const leftSpillPage = 'left';
  const rightSpillPage = 'right';
  const pageLeftBound = currentPageNumber - pageNeighbours;
  const pageRightBound = currentPageNumber + pageNeighbours;
  const beforeLastPage = totalPages - 1;
  const startPage = pageLeftBound > 2 ? pageLeftBound : 2;
  const endPage = pageRightBound < beforeLastPage ? pageRightBound : beforeLastPage;
  const leftSpill = startPage > 2;
  const rightSpill = endPage < beforeLastPage;

  const totalNumbers = pageNeighbours * 2 + 3;
  const totalBlocks = totalNumbers + 2;

  useEffect(() => {
    setHasPreviousControls(false);
    setHasNextControls(false);
    setCurrentPageNumber(1);
    setCurrentPageIndex(0);
  }, []);

  const handleGoToPage = (page) => {
    setCurrentPageNumber(Math.max(1, Math.min(page + 1, totalPages)));
    setCurrentPageIndex(Math.max(0, Math.min(page, totalPages - 1)));
    getDataFunc(page, itensPerPage, filterData, integrationFuncData, columns);
  };

  const handlePaginationClick = (e, page) => {
    e.preventDefault();
    handleGoToPage(page);
  };

  const handleMoveToPreviousPages = (e) => {
    e.preventDefault();
    handleGoToPage(currentPageIndex > currentPageIndex - 3 ? currentPageIndex - 1 : currentPageIndex - pageNeighbours * 2 - 1);
  };

  const handleMoveToNextPages = (e) => {
    e.preventDefault();
    handleGoToPage(currentPageIndex < currentPageIndex + 3 ? currentPageIndex + 1 : currentPageIndex + pageNeighbours * 2 + 1);
  };

  const handleControlsVisibility = () => {
    if (totalPages > totalBlocks) {
      setHasPreviousControls(true);
      setHasNextControls(true);
    }

    if (totalItens === 0) {
      setHasPreviousControls(false);
      setHasNextControls(false);
    }
  };

  useEffect(() => {
    handleControlsVisibility();
  }, [totalItens]);

  const formatpageNumber = () => {
    if (totalPages > totalBlocks) {
      let pages = [];

      pages = range(startPage, endPage);

      const pagesCount = pages.length;
      const singleSpillOffset = totalNumbers - pagesCount - 1;

      if (leftSpill && !rightSpill) {
        const extraPages = range(startPage - singleSpillOffset, startPage - 1);
        pages = [leftSpillPage, ...extraPages, ...pages];
      } else if (!leftSpill && rightSpill) {
        const extraPages = range(endPage + 1, endPage + singleSpillOffset);
        pages = [...pages, ...extraPages, rightSpillPage];
      } else if (leftSpill && rightSpill) {
        pages = [leftSpillPage, ...pages, rightSpillPage];
      }

      return [1, ...pages, totalPages];
    }

    return range(1, totalPages);
  };

  const pagesArr = formatpageNumber();

  return (
    <div className="pagination">
      {hasPreviousControls && (
        <div className="pagination__controls pagination__controls-previous">
          <EpButton
            actionType="button"
            buttonIcon={<FaAngleDoubleLeft className="btn__icon" />}
            linkFunc={e => handlePaginationClick(e, 0)}
            buttonType="secondary--link-secondary"
            customClass="btn"
            disabled={false}
            size="sm"
          />
          <EpButton
            actionType="button"
            buttonIcon={<FaCaretLeft className="btn__icon" />}
            linkFunc={e => handleMoveToPreviousPages(e)}
            buttonType="secondary--link-secondary"
            customClass="btn"
            disabled={currentPageNumber === 1}
            size="sm"
          />
        </div>
      )}

      <ul className="pagination__pages-list">
        {pagesArr.map((pageNumber) => {
          const pageIndex = pageNumber - 1;

          if (pageNumber === leftSpillPage) {
            return (
              <li key={pageNumber} className="pagination__pages-list-item">
                <EpButton
                  actionType="button"
                  labelText="..."
                  linkFunc={e => handleMoveToPreviousPages(e)}
                  buttonType="secondary-outline"
                  customClass="btn"
                  disabled={false}
                  size="sm"
                />
              </li>
            );
          }

          if (pageNumber === rightSpillPage) {
            return (
              <li key={pageNumber} className="pagination__pages-list-item">
                <EpButton
                  actionType="button"
                  labelText="..."
                  linkFunc={e => handleMoveToNextPages(e)}
                  buttonType="secondary-outline"
                  customClass="btn"
                  disabled={false}
                  size="sm"
                />
              </li>
            );
          }

          return (
            <li
              key={pageNumber}
              className={`pagination__pages-list-item ${currentPageNumber === pageNumber ? 'active' : ''}`}
            >
              <EpButton
                key={pageNumber}
                actionType="button"
                labelText={pageNumber}
                linkFunc={e => handlePaginationClick(e, pageIndex)}
                buttonType={currentPageNumber === pageNumber ? 'secondary' : 'secondary-outline'}
                customClass="btn"
                disabled={false}
                size="sm"
              />
            </li>
          );
        })}
      </ul>

      {hasNextControls && (
        <div className="pagination__controls pagination__controls-next">
          <EpButton
            actionType="button"
            buttonIcon={<FaCaretRight className="btn__icon" />}
            linkFunc={e => handleMoveToNextPages(e)}
            buttonType="secondary--link-secondary"
            customClass="btn"
            disabled={currentPageNumber === totalPages}
            size="sm"
          />
          <EpButton
            actionType="button"
            buttonIcon={<FaAngleDoubleRight className="btn__icon" />}
            linkFunc={e => handlePaginationClick(e, totalPages - 1)}
            buttonType="secondary--link-secondary"
            customClass="btn"
            disabled={false}
            size="sm"
          />
        </div>
      )}
    </div>
  );
};

export default EpPagination;

EpPagination.defaultProps = {
  tableData: null,
  filterData: null,
  pageNeighbours: 1,
};

EpPagination.propTypes = {
  tableData: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.object),
  ])),
  getDataFunc: PropTypes.func.isRequired,
  pageNeighbours: PropTypes.number,
  filterData: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ])),
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  integrationFuncData: PropTypes.func.isRequired,
  currentPageNumber: PropTypes.number.isRequired,
  setCurrentPageNumber: PropTypes.func.isRequired,

};
